import CciTrackingModule from './CciTrackingModule'

const CciEventTrackingPlugin = {
  install (Vue) {
    this.Vue = Vue
    this.Vue.config.globalProperties.$cciTrackingModule = new CciTrackingModule()
    // Vue.config.globalProperties.cciEventTracking = Vue.cciEventTracking = Object
    // if (options?.eventTrackingModule) {
    //   this.setEventTrackingModule(options.eventTrackingModule)
    // }
    this.Vue.config.globalProperties.$cciEventTrackingPlugin = this
  },
  trackEvent (...args) {
    if (!this.Vue.config.globalProperties.$cciTrackingModule) return
    this.Vue.config.globalProperties.$cciTrackingModule.trackEvent(...args)
  },
  // setEventTrackingModule (cciEventTracking) {
  //   this.Vue.config.globalProperties.$cciTrackingModule = cciEventTracking
  // },
  setApp (app) {
    this.Vue.config.globalProperties.$cciTrackingModule.app = app
  },
  setIssueData (issueData) {
    this.Vue.config.globalProperties.$cciTrackingModule.issueData = issueData
  }
}

export default CciEventTrackingPlugin
